import { render, staticRenderFns } from "./NewAlertIcon.vue?vue&type=template&id=0968ccf6"
import script from "./NewAlertIcon.vue?vue&type=script&lang=js"
export * from "./NewAlertIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports